<template>
  <div
      v-if="notifications && Object.keys(notifications).length > 0"
      class="cms5-flash-notification-wrap  p-2"
  >
    <div
        class="container"
    >
      <template
        v-for="(notification, n_index) in reversedNotifications"
        :key="notification.title"
      >
        <div
          class="row justify-content-md-center"
        >
          <div
              class="col col-12"
              @mouseenter="handleMessageMouseEnter(n_index, notification)"
              @mouseleave="handleMessageMouseLeave()"
              @click.prevent="handleMessageClick(n_index, notification)"
          >
            <div
                :class="['alert alert-' + notification.params.color_scheme + ' shadow-lg d-flex align-items-start mx-auto', { 'opacity-0': notification.isFade }]"
                :style="((notification.params.uri)? 'cursor: pointer; ': '') + 'transition: opacity ' + getConfig('push_notification.display.animation.value') + 'ms ease-in-out;' "
            >
              <i
                  :class="(notification.params.ico_class? notification.params.ico_class :'bi bi-info-circle-fill') + ' flex-shrink-0 me-3 mt-1'"
                  style="font-size: 1.5rem;"
              />

              <div>
                <small
                    class="w-100 text-end"
                >

                    <span
                        v-format-date="notification.send_date.date"
                        class="me-2"
                    />
                  <span
                      v-format-date:custom.time.timeOnly="notification.send_date.date"
                      class="me-2"
                  />

                </small>
                <h5
                    v-if="notification.title"
                    class="alert-heading mb-1"
                >
                  {{notification.title}}
                </h5>
                <div
                    v-if="notification.body"
                    class="mb-0"
                >
                  {{notification.body}}
                </div>
              </div>

              <button
                  @click.prevent="closePushNotification(n_index, notification)"
                  type="button"
                  class="btn-close ms-auto"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                  title="Close"
              />
            </div>
          </div>
        </div>
      </template>

      <template
          v-if="notifications && Object.keys(notifications).length > getConfig('push_notification.display.limit')"
      >
        <div
            class="row justify-content-md-center"
        >
          <div
              class="col col-12 -col-lg-8 text-end"
          >
            <router-link
              :to="'/push-notification/unread-notification'"
              class="btn btn-sm btn-light border-secondary"
            >
              {{ $t('notification.widget.more.title')}}
              <i class="bi bi-arrow-right"></i>
            </router-link>
          </div>
        </div>
      </template>
    </div>



<!--

    <display-debug class="bg-white">
      <template #debugView>reversedNotifications  {{getConfig('push_notification.display.limit')}}</template>
    </display-debug>

    <display-debug class="bg-white">
      <template #debugView>reversedNotifications  {{reversedNotifications}}</template>
    </display-debug>    <display-debug class="bg-white">
      <template #debugView>reversedNotifications  {{reversedNotifications}}</template>
    </display-debug>

    <display-debug>
      <template #debugView>notifications  {{notifications}}</template>
    </display-debug>
  -->
  </div>
</template>

<script>
import axios from "axios";
import { gsap, Back, Power1 } from "gsap"
import { globalPushState } from '@/main.js'; // cesta k vašemu souboru
//import { useMouse, useWindowFocus, useElementVisibility } from '@vueuse/core'

export default {
  name: "FlashMessages",
  components: [
    gsap,
    axios
  ],
  data() {
    return {
      notifications: [
        /*
       {
         "title": "PRVNI testovaci title #dev - 2026-02-19 | 16:00",
         //"body": "Všechny dosud vytvořené soubory včetně hesla si někam uložte. Ať se totiž změní domény, které provozujete lokálně, jen upravíte v3.ext",
         "params": {
           "color_scheme": "info",
           "url": "http://localhost:8080/#/gift-coupon/read-code",
           "title": "#1  Ahoj! 🚀",
           //"ico_class": "bi bi-gift",
           "body": "Toto je testovací zpráva z vašeho PHP serveru. 16:00:33",
           "uri": "/gift-coupon/read-code",
           "message_id": 13
         }
       },
       {
         //"title": "DRUHA testovaci title #dev - 2026-02-19 | 16:00",
         "body": "Všechny dosud vytvořené soubory včetně hesla si někam uložte. Ať se totiž změní domény, které provozujete lokálně, jen upravíte v3.ext",
         "params": {
           "color_scheme": "danger",
           //"url": "http://localhost:8080/#/gift-coupon/read-code",
           "title": "#1  Ahoj! 🚀",
           "ico_class": "bi bi-bell",
           "body": "Toto je testovací zpráva z vašeho PHP serveru. 16:00:33",
           //"uri": "/gift-coupon/read-code",
           "message_id": 14
         }
       },
       {
         "title": "PRVNI2 testovaci title #dev - 2026-02-19 | 16:00",
         "body": "Všechny dosud vytvořené soubory včetně hesla si někam uložte. Ať se totiž změní domény, které provozujete lokálně, jen upravíte v3.ext",
         "params": {
           "color_scheme": "info",
           "url": "http://localhost:8080/#/gift-coupon/read-code",
           "title": "#1  Ahoj! 🚀",
           //"ico_class": "bi bi-gift",
           "body": "Toto je testovací zpráva z vašeho PHP serveru. 16:00:33",
           "uri": "/gift-coupon/read-code",
           "message_id": 13
         }
       },
       {
         "title": "DRUHA2 testovaci title #dev - 2026-02-19 | 16:00",
         "body": "Všechny dosud vytvořené soubory včetně hesla si někam uložte. Ať se totiž změní domény, které provozujete lokálně, jen upravíte v3.ext",
         "params": {
           "color_scheme": "danger",
           //"url": "http://localhost:8080/#/gift-coupon/read-code",
           "title": "#1  Ahoj! 🚀",
           "ico_class": "bi bi-bell",
           "body": "Toto je testovací zpráva z vašeho PHP serveru. 16:00:33",
           //"uri": "/gift-coupon/read-code",
           "message_id": 14
         }
       },
       {
         "title": "PRVNI3 testovaci title #dev - 2026-02-19 | 16:00",
         "body": "Všechny dosud vytvořené soubory včetně hesla si někam uložte. Ať se totiž změní domény, které provozujete lokálně, jen upravíte v3.ext",
         "params": {
           "color_scheme": "info",
           "url": "http://localhost:8080/#/gift-coupon/read-code",
           "title": "#1  Ahoj! 🚀",
           //"ico_class": "bi bi-gift",
           "body": "Toto je testovací zpráva z vašeho PHP serveru. 16:00:33",
           "uri": "/gift-coupon/read-code",
           "message_id": 13
         }
       },
       {
         "title": "DRUHA3 testovaci title #dev - 2026-02-19 | 16:00",
         "body": "Všechny dosud vytvořené soubory včetně hesla si někam uložte. Ať se totiž změní domény, které provozujete lokálně, jen upravíte v3.ext",
         "params": {
           "color_scheme": "danger",
           //"url": "http://localhost:8080/#/gift-coupon/read-code",
           "title": "#1  Ahoj! 🚀",
           "ico_class": "bi bi-bell",
           "body": "Toto je testovací zpráva z vašeho PHP serveru. 16:00:33",
           //"uri": "/gift-coupon/read-code",
           "message_id": 14
         }
       }
       */
      ],
      hoverTimer: null,
      display_list: false,

    }
  },

  computed: {
    reversedNotifications() {
      return this.notifications.slice(0, this.getConfig('push_notification.display.limit'));
    },

    notification() {
      return globalPushState;
    },
    count() {
      return globalPushState.unreadCount;
    }
  },
  beforeUnmount() {
    if (this.hoverTimer) {
      clearTimeout(this.hoverTimer);
    }
  },
  methods: {
    async loadUnreadMessages() {
      axios.defaults.baseURL = this.getBaseRoot();
      await axios({
        url: this.getApiConfig('user.unread_push_messages.path'),
        method: this.getApiConfig('user.unread_push_messages.method'),
        withCredentials: true,
        headers: this.getRequestHeader(),
      }).then((res) => {
        if(
            typeof res.data.response.messages != 'undefined'
            && res.data.response.messages
            && res.data.response.messages.length > 0
        ) {
          for(const i in res.data.response.messages) {
            const isExist = this.notifications.some(object => object.id === res.data.response.messages[i].id);
            if(
                !isExist
                && typeof res.data.response.messages[i].id != 'undefined'
            ) {
              const messageObj = {
                'id': res.data.response.messages[i].id,
                "title": res.data.response.messages[i].title_ident,
                "body": res.data.response.messages[i].body_ident,
                "send_date": res.data.response.messages[i].send_date,
                "params": {
                  "color_scheme": res.data.response.messages[i].params.color_scheme ?? 'primary',
                  "ico_class": res.data.response.messages[i].params.ico_class ?? 'bi bi-info-circle',
                  "uri": res.data.response.messages[i].params.uri,
                  "message_id": res.data.response.messages[i].id
                }
              }
              this.notifications.unshift(messageObj)
            }
          }
        }
      });
    },

    async markAsRead(id) {
      axios.defaults.baseURL = this.getBaseRoot();
      await axios({
        url: this.getApiConfig('user.read_push_messages_by_id.path') + "?id=" + id,
        method: this.getApiConfig('user.read_push_messages_by_id.method'),
        withCredentials: true,
        headers: this.getRequestHeader(),
      }).then((res) => {
        //console.log('dev markAsRead', res.data)
      });

    },

    handleMessageClick(index, data) {
      //console.log("dev.handleMessageClick", data);
      if(data.params.message_id) {
        this.markAsRead(data.params.message_id);
        //console.log("dev.handleMessageClick CLICK-READ", data.params.message_id);
      }

      if(data.params.uri) {
        //console.log("dev.handleMessageClick REDIRECT", data.params.uri);
        this.$router.push(data.params.uri);
      }
    },

    handleMessageMouseEnter(index, data) {
      //data.isFade = true;
      this.hoverTimer = setTimeout(() => {
        data.isFade = true;
        if(data.params.message_id) {
          this.markAsRead(data.params.message_id);
          setTimeout(() =>
            {
                this.notifications.splice(index, index+1);
            },
              this.getConfig('push_notification.display.animation.value')
          );
        }
      }, this.getConfig('push_notification.display.mouseAfter.value'));
    },

    handleMessageMouseLeave() {
      //console.log("dev.handleMessageMouseEnter OFF");
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer);
        this.hoverTimer = null;
      }
    },

    async closePushNotification(index, push) {
      //console.log('dev closePushNotification',index, this.notifications[index])
      this.notifications.splice(index, index+1);
      if(
          push
          && push.params
          && push.params.message_id
          && 1 == 0
      ) {
        axios.defaults.baseURL = this.getBaseRoot();
        await axios({
          url: this.getApiConfig('user.read_push_messages_by_id.path') + "?id=" + push.params.message_id,
          method: this.getApiConfig('user.read_push_messages_by_id.method'),
          withCredentials: true,
          headers: this.getRequestHeader(),
        }).then((res) => {
          //console.log('dev closePushNotification MARK RES', res.data)
        });
      }
    },

  },

  mounted() {
    //this.loadUnreadMessages();
    setInterval(() =>
        {
          //this.loadUnreadMessages();
        },
        this.getConfig('push_notification.reload.interval')
    );
  },
  watch: {
    '$push': {
      handler(newVal, oldVal) {
        if(
            newVal
            && typeof newVal.data != 'undefined'
            && newVal.data
      ) {
          this.loadUnreadMessages();
        }
      },
      deep: true,
      immediate: true
    },
    'notifications': {
      handler(newVal, oldVal) {
/*
        console.log('dev watch notification', newVal)
        const dt = new Date();
        this.$push = dt;
        this.$.appContext.config.globalProperties.$push = dt;
        //this.config.globalProperties.$push = dt;
      */
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    let is_active_viewport;
  }
};
</script>
<style scoped lang="scss">

  .cms5-flash-notification-wrap {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    z-index: 1000;
    //background: #2c3e50;

    @media (min-width: 768px) {
      left: 10%;
      right: 10%;
    }

    // Large (lg) - Desktopy a větší (>= 992px)
    @media (min-width: 992px) {
      left: 50%;
      right: 1%;
    }




  }

.fade-out-element {
  //transition: opacity 2000ms ease-in-out;
  cursor: pointer;
}

/* Bootstrap třída .opacity-0 nastaví opacity: 0,
   ale díky naší transition to bude plynulé */
</style>